import { CONFIG_PROPS, PLACEMENTS, ICON_TYPES } from './utils';
import Notify from './Notify';
import { classNames } from '@speechki-frontend/shared/helpers/functions';
// import { IconTick } from '@speechki-frontend/shared/ui/icons';

let defaultConfig = {};
const notifyInstance = {};

function setConfig(conf = {}) {
    defaultConfig = { ...defaultConfig, ...CONFIG_PROPS(conf) };
}

function getPlacementStyle(opts = {}) {
    const { placement, top, bottom } = { ...defaultConfig, ...opts };
    let style;

    switch (placement) {
        case 'top-left':
            style = {
                left: '10px',
                top,
                bottom: 'auto'
            };
            break;
        case 'top-right':
            style = {
                right: '10px',
                top,
                bottom: 'auto'
            };
            break;
        case 'bottom-left':
            style = {
                left: '10px',
                top: 'auto',
                bottom
            };
            break;
        default:
            style = {
                right: '10px',
                top: 'auto',
                bottom
            };
            break;
    }

    return style;
}

function getInstance(opts = {}, cb = () => {}) {
    const {
        prefixCls: customizePrefixCls,
        placement,
        rtl,
        appContext,
        getContainer,
        top,
        bottom,
        closeIcon,
        maxCount
    } = {
        ...defaultConfig,
        ...opts
    };
    const prefixCls = customizePrefixCls || 'notify';
    const cacheKey = `${prefixCls}-${placement}-${rtl}`;
    const cacheInstance = notifyInstance[cacheKey];

    if (cacheInstance) {
        Promise.resolve(cacheInstance).then(instance => cb(instance));
        return;
    }

    const notifyClass = classNames(`${prefixCls}-${placement}`, {
        [`${prefixCls}-rtl`]: rtl === true
    });

    Notify.newInstance(
        {
            name: 'notify',
            prefixCls: customizePrefixCls,
            class: notifyClass,
            style: getPlacementStyle({ placement, top, bottom }),
            appContext,
            getContainer,
            closeIcon,
            maxCount
        },
        notify => {
            notifyInstance[cacheKey] = notify;
            cb(notify);
        }
    );
}

const open = args => {
    const { icon, description, message, btn, placement } = args;
    const duration = args.duration === undefined ? defaultConfig.duration : args.duration;
    const type = args.type === undefined ? defaultConfig.type : args.type;

    getInstance(args, notify => {
        notify.notice({
            duration,
            closable: true,
            onClose: args.onClose,
            onClick: args.onClick,
            key: args.key,
            style: args.style || {},
            class: args.class,
            placement: args.placement,
            type,
            description,
            message
        });
    });
};

const api = {
    open,
    close(key) {
        Object.keys(notifyInstance).forEach(cacheKey =>
            Promise.resolve(notifyInstance[cacheKey]).then(instance => {
                instance.removeNotice(key);
            })
        );
    },
    config: setConfig,
    destroy() {
        Object.keys(notifyInstance).forEach(cacheKey => {
            Promise.resolve(notifyInstance[cacheKey]).then(instance => {
                instance.destroy();
            });
            delete notifyInstance[cacheKey];
        });
    }
};

const plugin = {
    install(app, options = {}) {
        api.config(options);
        app.component('Notify', Notify);
        app.config.globalProperties.$notify = api;
    }
};

ICON_TYPES.forEach(type => {
    api[type] = args => api.open({ ...args, type });
});

export { plugin as NotifyPlugin, api as Notify };
